import { Link } from "react-router-dom";
import CustomTextField from "../../Custom/CustomTextField";
import { Button } from "@mui/material";

const FormContent = ({ handleSubmit, formData, setFormData, loading }) => {
  return (
    <div className="form-container" name="rest-password-form">
      <form onSubmit={handleSubmit} id="forgot-form">
        <div className="access-header">
          <h2 className="form-title">Forgot Your Password?</h2>
          <p>Fill out the form below to reset your password</p>
        </div>
        <CustomTextField
          label="Email"
          name="email"
          type="email"
          color="black"
          required
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />
        <CustomTextField
          label="Username"
          name="username"
          color="black"
          required
          value={formData.username}
          onChange={(e) =>
            setFormData({ ...formData, username: e.target.value })
          }
        />
        <CustomTextField
          label="New Password"
          name="password"
          color="black"
          style={{
            marginBottom: "1rem",
          }}
          required
          value={formData.password}
          onChange={(e) =>
            setFormData({ ...formData, password: e.target.value })
          }
        />
        <Button
          color="black"
          variant="contained"
          type="submit"
          disableElevation
          disabled={Object.values(formData).some((x) => x === "") || loading}
        >
          {!loading ? "Submit" : "Loading..."}
        </Button>
        <div className="bottom-actions">
          Have an account?
          <Link to="/login">Login</Link>
        </div>
      </form>
    </div>
  );
};

export default FormContent;
